export enum Level {
  Basic = 1,
  Intermediate = 2,
  Advanced = 3,
}
